import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { map, take } from 'rxjs/operators';

import { AuthService } from '../services/auth.service';

export const forgotPasswordGuard: CanActivateFn = () => {
  const auth = inject(AuthService);

  return auth.isAuthenticated.pipe(take(1), map(isAuth => {
    if (isAuth) {
      auth.logout();
    }
    return true;
  }));
};
